import dkAxios from '@/jslib/dk-axios'

export const getStyleList = data => dkAxios({
  url: '/v1/cms/Style',
  method: 'GET',
  params: data,
});

export const deleteStyle = data => dkAxios({
  url: `/v1/cms/Style/delete`,
  method: 'POST',
  data
})

export const addStyle = data => dkAxios({
  url: '/v1/cms/Style/save',
  method: 'POST',
  data
})

export const editStyle = data => dkAxios({
  url: '/v1/cms/Style/update',
  method: 'POST',
  data
})

export const getStyleDetail = data => dkAxios({
  url: '/v1/cms/Style/getStyle',
  method: 'POST',
  data
})

export const getBannerList = data => dkAxios({
  url: '/v1/cms/ExampleBanner',
  method: 'GET',
  params: data,
})

export const addBanner = data => dkAxios({
  url: '/v1/cms/ExampleBanner',
  method: 'POST',
  data,
})

export const editBanner = data => dkAxios({
  url: `/v1/cms/ExampleBanner/${data.uuid}`,
  method: 'PUT',
  data,
})

export const getBannerDetail = data => dkAxios({
  url: `/v1/cms/ExampleBanner/getExampleBanner`,
  method: 'POST',
  data,
})

export const deleteBanner = data => dkAxios({
  url: `/v1/cms/ExampleBanner/delete/`,
  method: 'POST',
  data,
})

export const getExampleList = data => dkAxios({
  url: '/v1/cms/Example',
  method: 'GET',
  params: data,
})

export const setExampleStatus = data => dkAxios({
  url: '/v1/cms/Example/upAudit',
  method: 'POST',
  params: data,
})

export const getExampleDetail = data => dkAxios({
  url: '/v1/cms/Example/getExample',
  method: 'POST',
  params: data,
})

export const addExample = data => dkAxios({
  url: '/v1/cms/Example/save',
  method: 'POST',
  data,
})

export const editExample = data => dkAxios({
  url: '/v1/cms/Example/update',
  method: 'POST',
  data,
})

export const deleteExample = data => dkAxios({
  url: '/v1/cms/Example/delete',
  method: 'POST',
  data,
})

export const startExample = data => dkAxios({
  url: '/v1/cms/Example/startExample',
  method: 'POST',
  data,
})

export const getStyle = () => dkAxios({
  url: '/v1/cms/Style',
  method: 'GET',
})

export const getBrand = () => dkAxios({
  url: '/v1/cms/Brand',
  method: 'GET',
  params: {page_size: 1000},
})

export const getCity = () => dkAxios({
  url: '/region.json',
  method: 'GET',
})



// WEBPACK FOOTER //
// ./src/api/case.js